import { Component, Input } from "@angular/core";
import { SubNavOption } from "@webapp/navigation/models/sub-nav-options.models";
import { Ng1StateProxy } from "@gtmhub/core/routing";

@Component({
  selector: "gh-sub-nav-options",
  templateUrl: "./sub-nav-options.component.html",
  styleUrls: ["./sub-nav-options.component.less"],
})
export class SubNavOptionsComponent {
  @Input()
  public options: SubNavOption[];

  constructor(private ng1StateProxy: Ng1StateProxy) {}

  public isActive(option: SubNavOption): boolean {
    const areCurrentAndOptionStatesEqual = this.ng1StateProxy.getCurrentState() === option.state;

    if (option.state === "gtmhub.insightboard") {
      const idParamValue = this.ng1StateProxy.getParam("dashboardId");
      return areCurrentAndOptionStatesEqual && idParamValue === option.stateOptions.dashboardId;
    }

    return areCurrentAndOptionStatesEqual;
  }

  public view(option: SubNavOption): void {
    this.ng1StateProxy.go(option.state, option.stateOptions);
  }
}
